// type TabHeightMode = 'animate' | 'instant' | 'fixed';

// interface TabSwitchOptions
// {
//   tabSelector: string;
//   panelSelector: string;
//   activeClassName?: string;
//   initialIndex?: number;
//   heightMode?: TabHeightMode;

//   /**
//    * クリック対象が子要素になるケース（画像やspan等）でも拾えるように、
//    * デリゲーション用の「最終トリガー要素」を定義したい場合に使う
//    * 未指定なら tabSelector を closest で拾う
//    */
//   tabClosestSelector?: string;
// }

// export class TabSwitcher
// {
//   private readonly mRoot: Document | HTMLElement;

//   constructor(root: Document | HTMLElement)
//   {
//     this.mRoot = root;
//   }

//   public applyTabs(options: TabSwitchOptions): void
//   {
//     const active_class: string = options.activeClassName ?? 'is_active';
//     const height_mode: TabHeightMode = options.heightMode ?? 'animate';

//     const panel_nodes: NodeListOf<HTMLElement> =
//       this.mRoot.querySelectorAll<HTMLElement>(options.panelSelector);
//     const panels: HTMLElement[] = Array.from(panel_nodes);

//     if (!panels.length)
//     {
//       return;
//     }

//     const panel_container = panels[0].parentElement as HTMLElement | null;
//     if (!panel_container)
//     {
//       return;
//     }

//     const container_parent: HTMLElement | null = panel_container.parentElement;
//     if (!container_parent)
//     {
//       return;
//     }

//     if (height_mode === 'instant' || height_mode === 'fixed')
//     {
//       panel_container.style.transition = 'none';
//     }

//     const createMeasureContainer: () => HTMLElement = (): HTMLElement =>
//     {
//       const measure_container = document.createElement('section');
//       measure_container.className = `${panel_container.className} is_measuring`;
//       measure_container.setAttribute('aria-hidden', 'true');

//       measure_container.style.position = 'absolute';
//       measure_container.style.visibility = 'hidden';
//       measure_container.style.pointerEvents = 'none';
//       measure_container.style.insetBlockStart = '0';
//       measure_container.style.insetInlineStart = '0';
//       measure_container.style.width = `${panel_container.clientWidth}px`;

//       container_parent.appendChild(measure_container);
//       return measure_container;
//     };

//     const measurePanelHeight = (panel: HTMLElement, shared_container?: HTMLElement): number =>
//     {
//       const measure_container: HTMLElement = shared_container ?? createMeasureContainer();

//       measure_container.innerHTML = '';
//       measure_container.style.width = `${panel_container.clientWidth}px`;

//       const clone = panel.cloneNode(true) as HTMLElement;
//       clone.classList.add(active_class);

//       clone.removeAttribute('hidden');
//       clone.setAttribute('aria-hidden', 'true');
//       clone.removeAttribute('id');

//       measure_container.appendChild(clone);

//       const height: number = clone.offsetHeight;

//       if (!shared_container)
//       {
//         measure_container.remove();
//       }

//       return height;
//     };

//     const computeMaxPanelHeight: () => number = (): number =>
//     {
//       let max_height: number = 0;
//       const shared_container: HTMLElement = createMeasureContainer();

//       panels.forEach((panel: HTMLElement) =>
//       {
//         const height: number = measurePanelHeight(panel, shared_container);
//         if (height > max_height)
//         {
//           max_height = height;
//         }
//       });

//       shared_container.remove();
//       return max_height;
//     };

//     const updateContainerHeight = (active_panel: HTMLElement): void =>
//     {
//       if (height_mode === 'fixed')
//       {
//         const max_height: number = computeMaxPanelHeight();
//         if (max_height > 0)
//         {
//           panel_container.style.height = `${max_height}px`;
//         }
//         return;
//       }

//       const target_height: number = measurePanelHeight(active_panel);
//       panel_container.style.height = `${target_height}px`;
//     };

//     // --- ここからが「clone対策の本体」 ---

//     const getTabTargetKey = (tab: HTMLElement): string | null =>
//     {
//       const data_target = tab.getAttribute('data-tab-target');
//       if (data_target && data_target.trim() !== '')
//       {
//         return data_target.trim();
//       }

//       const aria_controls = tab.getAttribute('aria-controls');
//       if (aria_controls && aria_controls.trim() !== '')
//       {
//         return aria_controls.trim();
//       }

//       return null;
//     };

//     const findPanelByKey = (key: string): HTMLElement | null =>
//     {
//       const panel = panels.find((p: HTMLElement) => p.id === key);
//       return panel ?? null;
//     };

//     const setActiveByKey = (key: string): void =>
//     {
//       const active_panel = findPanelByKey(key);
//       if (!active_panel)
//       {
//         return;
//       }

//       // タブは slick clone を含めて毎回取り直す（重要）
//       const tab_nodes: NodeListOf<HTMLElement> =
//         this.mRoot.querySelectorAll<HTMLElement>(options.tabSelector);
//       const tabs: HTMLElement[] = Array.from(tab_nodes);

//       // tabs 側は「同じ key のものを全部アクティブ」にする（clone同期）
//       tabs.forEach((tab: HTMLElement) =>
//       {
//         const tab_key = getTabTargetKey(tab);
//         const is_active = tab_key === key;

//         tab.classList.toggle(active_class, is_active);
//         tab.setAttribute('aria-selected', is_active ? 'true' : 'false');
//         tab.setAttribute('tabindex', is_active ? '0' : '-1');
//       });

//       // panels 側は key で1つだけアクティブ
//       panels.forEach((panel: HTMLElement) =>
//       {
//         const is_active = panel.id === key;

//         panel.classList.toggle(active_class, is_active);
//         panel.setAttribute('aria-hidden', is_active ? 'false' : 'true');
//         panel.toggleAttribute('hidden', !is_active);
//       });

//       updateContainerHeight(active_panel);
//     };

//     // 初期状態：initialIndex を panel id に変換して適用
//     const initial_index: number = Math.max(0, Math.min(options.initialIndex ?? 0, panels.length - 1));
//     const initial_key: string = panels[initial_index].id;
//     if (initial_key)
//     {
//       setActiveByKey(initial_key);
//     }

//     window.addEventListener('resize', () =>
//     {
//       const current_panel = panels.find((p: HTMLElement) => !p.hasAttribute('hidden')) ?? panels[0];
//       updateContainerHeight(current_panel);
//     });

//     // クリック：イベントデリゲーション（slick clone 後でも拾える）
//     const closest_selector: string = options.tabClosestSelector ?? options.tabSelector;

//     this.mRoot.addEventListener('click', (ev: Event) =>
//     {
//       if (!(ev instanceof MouseEvent))
//       {
//         return;
//       }

//       const target = ev.target as Element | null;
//       if (!target)
//       {
//         return;
//       }

//       const tab = target.closest(closest_selector) as HTMLElement | null;
//       if (!tab)
//       {
//         return;
//       }

//       if (!tab.matches(options.tabSelector))
//       {
//         return;
//       }

//       const key = getTabTargetKey(tab);
//       if (!key)
//       {
//         return;
//       }

//       ev.preventDefault();
//       setActiveByKey(key);
//     });
//   }
// }



type TabHeightMode = 'animate' | 'instant' | 'fixed';

interface TabSwitchOptions
{
  tabSelector: string;
  panelSelector: string;
  activeClassName?: string;
  initialIndex?: number;
  heightMode?: TabHeightMode;

  /**
   * クリック対象が子要素になるケース（画像やspan等）でも拾えるように、
   * デリゲーション用の「最終トリガー要素」を定義したい場合に使う
   * 未指定なら tabSelector を closest で拾う
   */
  tabClosestSelector?: string;
}

export class TabSwitcher
{
  private readonly mRoot: Document | HTMLElement;

  constructor(root: Document | HTMLElement)
  {
    this.mRoot = root;
  }

  public applyTabs(options: TabSwitchOptions): void
  {
    const active_class: string = options.activeClassName ?? 'is_active';
    const height_mode: TabHeightMode = options.heightMode ?? 'animate';

    const panel_nodes: NodeListOf<HTMLElement> =
      this.mRoot.querySelectorAll<HTMLElement>(options.panelSelector);
    const panels: HTMLElement[] = Array.from(panel_nodes);

    if (!panels.length)
    {
      return;
    }

    const panel_container = panels[0].parentElement as HTMLElement | null;
    if (!panel_container)
    {
      return;
    }

    const container_parent: HTMLElement | null = panel_container.parentElement;
    if (!container_parent)
    {
      return;
    }

    if (height_mode === 'instant' || height_mode === 'fixed')
    {
      panel_container.style.transition = 'none';
    }

    const createMeasureContainer: () => HTMLElement = (): HTMLElement =>
    {
      const measure_container = document.createElement('section');
      measure_container.className = `${panel_container.className} is_measuring`;
      measure_container.setAttribute('aria-hidden', 'true');

      measure_container.style.position = 'absolute';
      measure_container.style.visibility = 'hidden';
      measure_container.style.pointerEvents = 'none';
      measure_container.style.insetBlockStart = '0';
      measure_container.style.insetInlineStart = '0';
      measure_container.style.width = `${panel_container.clientWidth}px`;

      container_parent.appendChild(measure_container);
      return measure_container;
    };

    const measurePanelHeight = (panel: HTMLElement, shared_container?: HTMLElement): number =>
    {
      const measure_container: HTMLElement = shared_container ?? createMeasureContainer();

      measure_container.innerHTML = '';
      measure_container.style.width = `${panel_container.clientWidth}px`;

      const clone = panel.cloneNode(true) as HTMLElement;
      clone.classList.add(active_class);

      clone.removeAttribute('hidden');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');

      measure_container.appendChild(clone);

      const height: number = clone.offsetHeight;

      if (!shared_container)
      {
        measure_container.remove();
      }

      return height;
    };

    const computeMaxPanelHeight: () => number = (): number =>
    {
      let max_height: number = 0;
      const shared_container: HTMLElement = createMeasureContainer();

      panels.forEach((panel: HTMLElement) =>
      {
        const height: number = measurePanelHeight(panel, shared_container);
        if (height > max_height)
        {
          max_height = height;
        }
      });

      shared_container.remove();
      return max_height;
    };

    const updateContainerHeight = (active_panel: HTMLElement): void =>
    {
      if (height_mode === 'fixed')
      {
        const max_height: number = computeMaxPanelHeight();
        if (max_height > 0)
        {
          panel_container.style.height = `${max_height}px`;
        }
        return;
      }

      const target_height: number = measurePanelHeight(active_panel);
      panel_container.style.height = `${target_height}px`;
    };

    // --- ここからが「clone対策の本体」 ---

    const getTabTargetKey = (tab: HTMLElement): string | null =>
    {
      const data_target = tab.getAttribute('data-tab-target');
      if (data_target && data_target.trim() !== '')
      {
        return data_target.trim();
      }

      const aria_controls = tab.getAttribute('aria-controls');
      if (aria_controls && aria_controls.trim() !== '')
      {
        return aria_controls.trim();
      }

      return null;
    };

    const findPanelByKey = (key: string): HTMLElement | null =>
    {
      const panel = panels.find((p: HTMLElement) => p.id === key);
      return panel ?? null;
    };

    const setActiveByKey = (key: string): void =>
    {
      const active_panel = findPanelByKey(key);
      if (!active_panel)
      {
        return;
      }

      // タブは slick clone を含めて毎回取り直す（重要）
      const tab_nodes: NodeListOf<HTMLElement> =
        this.mRoot.querySelectorAll<HTMLElement>(options.tabSelector);
      const tabs: HTMLElement[] = Array.from(tab_nodes);

      // tabs 側は「同じ key のものを全部アクティブ」にする（clone同期）
      tabs.forEach((tab: HTMLElement) =>
      {
        const tab_key = getTabTargetKey(tab);
        const is_active = tab_key === key;

        tab.classList.toggle(active_class, is_active);
        tab.setAttribute('aria-selected', is_active ? 'true' : 'false');
        tab.setAttribute('tabindex', is_active ? '0' : '-1');
      });

      // panels 側は key で1つだけアクティブ
      panels.forEach((panel: HTMLElement) =>
      {
        const is_active = panel.id === key;

        panel.classList.toggle(active_class, is_active);
        panel.setAttribute('aria-hidden', is_active ? 'false' : 'true');
        panel.toggleAttribute('hidden', !is_active);
      });

      updateContainerHeight(active_panel);

      // 重要：slick が aria-hidden を付け替えた後に「見えているタブ」にフォーカスを寄せる
      requestAnimationFrame(() =>
      {
        focusVisibleTabByKey(key);
      });

    };

    // 初期状態：initialIndex を panel id に変換して適用
    const initial_index: number = Math.max(0, Math.min(options.initialIndex ?? 0, panels.length - 1));
    const initial_key: string = panels[initial_index].id;
    if (initial_key)
    {
      setActiveByKey(initial_key);
    }

    window.addEventListener('resize', () =>
    {
      const current_panel = panels.find((p: HTMLElement) => !p.hasAttribute('hidden')) ?? panels[0];
      updateContainerHeight(current_panel);
    });

    const isInHiddenSlickSlide = (el: HTMLElement): boolean =>
    {
      const slide = el.closest('.slick-slide') as HTMLElement | null;
      if (!slide)
      {
        return false;
      }

      // clone は「支援技術的に別物」なのでフォーカス先として避ける
      if (slide.classList.contains('slick-cloned'))
      {
        return true;
      }

      return slide.getAttribute('aria-hidden') === 'true';
    };

    const focusVisibleTabByKey = (key: string): void =>
    {
      const tab_nodes = this.mRoot.querySelectorAll<HTMLElement>(options.tabSelector);
      const tabs = Array.from(tab_nodes).filter((t) => getTabTargetKey(t) === key);

      if (!tabs.length)
      {
        return;
      }

      const visible_tab =
        tabs.find((t) =>
          t.getAttribute('aria-hidden') !== 'true' &&
          !isInHiddenSlickSlide(t)
        ) ?? tabs[0];

      // スクロール暴れを避ける
      visible_tab.focus({ preventScroll: true });
    };


    // クリック：イベントデリゲーション（slick clone 後でも拾える）
    const closest_selector: string = options.tabClosestSelector ?? options.tabSelector;

    this.mRoot.addEventListener('click', (ev: Event) =>
    {
      if (!(ev instanceof MouseEvent))
      {
        return;
      }

      const target = ev.target as Element | null;
      if (!target)
      {
        return;
      }

      const tab = target.closest(closest_selector) as HTMLElement | null;
      if (!tab)
      {
        return;
      }

      if (!tab.matches(options.tabSelector))
      {
        return;
      }

      const key = getTabTargetKey(tab);
      if (!key)
      {
        return;
      }

      ev.preventDefault();
      setActiveByKey(key);
    });

  }
}